import { render, staticRenderFns } from "./DisplaySwitch.vue?vue&type=template&id=334be584&scoped=true&"
import script from "./DisplaySwitch.vue?vue&type=script&lang=js&"
export * from "./DisplaySwitch.vue?vue&type=script&lang=js&"
import style0 from "./DisplaySwitch.vue?vue&type=style&index=0&id=334be584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334be584",
  null
  
)

export default component.exports